<template>
	<el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" title="更换支付方式" :visible.sync="dialogVisible" destroy-on-close width="800px">
		<div v-if="dialogVisible">
			<ul class="pay-methods">
				<li 
					@click="handleChangeType(0)" 
					:class="{ 'active': payType === 0 }"
				>
					<img src="@/assets/images/weixin.png" alt="" />
					<p>微信支付</p>
				</li>
				<li 
					@click="handleChangeType(1)" 
					:class="{ 'active': payType === 1 }"
				>
					<img src="@/assets/images/zhifubao.png" alt="" />
					<p>支付宝支付</p>
				</li>
				<li v-if="noOfflineTransfer"
					@click="handleChangeType(2)" 
					:class="{ 'active': payType === 2 }"
				>
					<img src="@/assets/images/dgzz.png" alt=""  />
					<p>对公转账</p>
				</li>
			</ul>
			<p class="vip-desc">温馨提示：修改支付方式后，将影响之前订单的支付方式。</p>
		</div>
		<template #footer>
			<div class="dialog-footer">
				<el-button size="small" @click="handleClose">关闭</el-button>
				<el-button size="small" type="primary" @click="handleConfirm" v-click-once> 确定 </el-button>
			</div>
		</template>
	</el-dialog>
</template>

<script>
import { postConsumerOrderChangePayType } from '@/api/order/order.js';
export default {
	name: 'DialogChangePayType',
	props: {
		tradeNo: {
			type: String,
			default: true
		},
		noOfflineTransfer: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			dialogVisible: false,
			payType: 0
		};
	},
	methods: {
		// 打开对话框
		open(currentPayType = null) {
			this.dialogVisible = true;
			// 如果提供了当前支付方式，则设置为默认选中
			if (currentPayType !== null && currentPayType !== undefined) {
				this.payType = currentPayType;
			} else {
				this.payType = 0; // 默认选中微信支付
			}
			
			// 添加打开动画
			this.$nextTick(() => {
				const payMethods = document.querySelectorAll('.pay-methods li');
				payMethods.forEach((method, index) => {
					setTimeout(() => {
						method.style.opacity = '0';
						method.style.transform = 'translateY(10px)';
						setTimeout(() => {
							method.style.transition = 'all 0.3s ease';
							method.style.opacity = '1';
							method.style.transform = 'translateY(0)';
						}, 50);
					}, index * 100);
				});
			});
		},

		handleChangeType(type) {
			this.payType = type;
			
			// 添加视觉反馈
			const typeNames = ['微信支付', '支付宝支付', '对公转账'];
			// this.$message.success(`已选择：${typeNames[type]}`);
			
			// 添加选中动画效果
			this.$nextTick(() => {
				const activeElement = document.querySelector('.pay-methods li.active');
				if (activeElement) {
					activeElement.style.transform = 'scale(1.02)';
					setTimeout(() => {
						activeElement.style.transform = '';
					}, 200);
				}
			});
		},

		handleClose() {
			this.dialogVisible = false;
		},

		handleConfirm() {
			// 验证是否选择了支付方式
			if (this.payType === null || this.payType === undefined) {
				this.$message.warning('请选择支付方式');
				return;
			}
			
			const params = {
				tradeNo: this.tradeNo,
				payType: this.payType
			};
			
			// 显示确认提示
			const payTypeNames = ['微信支付', '支付宝支付', '对公转账'];
			const selectedPayType = payTypeNames[this.payType] || '未知支付方式';

           postConsumerOrderChangePayType(params).then((res) => {
               if (res.code === 200) {
					this.$message.success('支付方式修改成功');
					this.$emit('changePayType', params);
					this.dialogVisible = false;
				} else {
					this.$message.error(res.msg || '支付方式修改失败');
				}
           })

            return
			
			this.$confirm(`确定将支付方式更改为 ${selectedPayType} 吗？`, '确认更改', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				// 用户确认后执行更改
				return postConsumerOrderChangePayType(params);
			}).then(res => {
				if (res.code === 200) {
					this.$message.success('支付方式修改成功');
					this.$emit('changePayType', this.payType);
					this.dialogVisible = false;
				} else {
					this.$message.error(res.msg || '支付方式修改失败');
				}
			}).catch(() => {
				// 用户取消或请求失败
				// console.log('用户取消更改支付方式');
			});
		}
	}
};
</script>

<style lang="less" scoped>
ul li {
	margin: 0;
	padding: 0;
	list-style: none;
}

.pay-methods {
	display: flex;
	align-items: center;
	gap: 20px;
	padding-left: 0;

	li {
			padding: 8px 30px;
			border: 1px solid #ccc;
			background-color: #fff;
			border-radius: 12px;
			display: flex;
			justify-content: center;
			align-items: center;
			cursor: pointer;
			transition: all 0.3s ease;

			// &:hover {
			//     border-color: #da251c;
			// }

			p {
				font-size: 14px;
				color: #666;
				margin-left: 6px;
			}
			
			// 激活状态样式
			&.active {
				border-color: #155dfc;
				background-color: #eff6ff;
				box-shadow: 0 2px 8px rgba(64, 158, 255, 0.2);
				transform: translateY(-1px);
				
				p {
					color: #155dfc;
					font-weight: 500;
				}
				
				img {
					filter: brightness(1.1);
				}
			}
			
			// 悬停效果
			&:hover {
				border-color: #155dfc;
				transform: translateY(-1px);
				box-shadow: 0 4px 12px rgba(64, 158, 255, 0.15);
				
				p {
					color: #155dfc;
				}
			}
			
			// 点击效果
			&:active {
				transform: translateY(0) scale(0.98);
				box-shadow: 0 1px 4px rgba(64, 158, 255, 0.2);
			}
		}
}
// 弹出框重置样式
/deep/ .el-dialog__header {
	border-bottom: 1px dashed #e2e8f0;
	margin-right: 0;
	background: #f8fafc;
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
	color: #3a434f;
	font-size: 24px;
}

/deep/ .el-dialog__footer {
	border-top: 1px solid #e8e8e8;
	padding: 18px;
}

/deep/ .el-dialog__body .el-form-item__label {
	line-height: 26px;
}
</style>
